export const config = {
  default: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://mr.xymind.net:9901/cent-talkback",
      device: "https://mr.xymind.net:9901/cent-device",
      socketLogin: "https://mr.xymind.net:9901/cent-message",
      business: "https://mr.xymind.net:9901/platform-business",
      park: "https://mr.xymind.net:9901/cent-zone-operation",
      eesd: "https://mr.xymind.net:9901/cent-eesd",
      auth: "https://mr.xymind.net:9901/cent-auth",
      ifmDynamicServeUrl: "https://mr.xymind.net:9901/cent-consumer",
      residence: "https://mr.xymind.net:9901/platform-residence",
      finance: "https://mr.xymind.net:9901/cent-biz-fin",
      face: "https://mr.xymind.net:9901/cent-face",
      iotDate: "https://mr.xymind.net:9901/cent-iot-data/",
      industrial: "https://mr.xymind.net:9901/platform-industrial",
      upgrade: "https://mr.xymind.net:9901/cent-upgrade",
      attendance: "https://mr.xymind.net:9901/cent-attendance",
      product: "https://mr.xymind.net:9901/cent-product",
      flow: "https://mr.xymind.net:9901/cent-workflow",
      sdkAppId: 1400528184,
      h5View: "/h5/view/",
      healthAged: "https://mr.xymind.net:9901/platform-health-aged",
      smarthome: "https://mr.xymind.net:9901/cent-smarthome",
      meeting: "https://mr.xymind.net:9901/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://mr.xymind.net:9901/cent-oam",
      iotProduct: "https://mr.xymind.net:9901/productcore-webapi",
      iotService: "https://mr.xymind.net:9901/devicecore-webapi",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
      service: "https://mr.xymind.net:9901/service-alliance",
    },
    dev: {
      common: "https://mr.xymind.net:9901",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://mr.xymind.net:9901/cent-talkback",
      device: "https://mr.xymind.net:9901/cent-device",
      socketLogin: "https://mr.xymind.net:9901/cent-message",
      business: "https://mr.xymind.net:9901/platform-business",
      park: "https://mr.xymind.net:9901/cent-zone-operation",
      eesd: "https://mr.xymind.net:9901/cent-eesd",
      auth: "https://mr.xymind.net:9901/cent-auth",
      ifmDynamicServeUrl: "https://mr.xymind.net:9901/cent-consumer",
      residence: "https://mr.xymind.net:9901/platform-residence",
      finance: "https://mr.xymind.net:9901/cent-biz-fin",
      face: "https://mr.xymind.net:9901/cent-face",
      iotDate: "https://mr.xymind.net:9901/cent-iot-data/",
      industrial: "https://mr.xymind.net:9901/platform-industrial",
      upgrade: "https://mr.xymind.net:9901/cent-upgrade",
      attendance: "https://mr.xymind.net:9901/cent-attendance",
      product: "https://mr.xymind.net:9901/cent-product",
      flow: "https://mr.xymind.net:9901/cent-workflow",
      sdkAppId: 1400528184,
      h5View: "/h5/view/",
      healthAged: "https://mr.xymind.net:9901/platform-health-aged",
      smarthome: "https://mr.xymind.net:9901/cent-smarthome",
      meeting: "https://mr.xymind.net:9901/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://mr.xymind.net:9901/cent-oam",
      iotProduct: "https://mr.xymind.net:9901/productcore-webapi",
      iotService: "https://mr.xymind.net:9901/devicecore-webapi",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
      service: "https://mr.xymind.net:9901/service-alliance",
    },
    test: {
      common: "https://cent.xymind.net:19900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent.xymind.net:19900/cent-data-core",
      workorder: "https://cent.xymind.net:19900/cent-order",
      school: "https://cent.xymind.net:19900/platform-campus",
      patrol: "https://cent.xymind.net:19900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xymind.net:19900/cent-question",
      security: "https://cent.xymind.net:19900/cent-security",
      vehicle: "https://cent.xymind.net:19900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent.xymind.net:19900/cent-talkback",
      device: "https://cent.xymind.net:19900/cent-device",
      socketLogin: "https://cent.xymind.net:19900/cent-message",
      business: "https://cent.xymind.net:19900/platform-business",
      park: "https://cent.xymind.net:19900/cent-zone-operation",
      eesd: "https://cent.xymind.net:19900/cent-eesd",
      auth: "https://cent.xymind.net:19900/cent-auth",
      ifmDynamicServeUrl: "https://cent.xymind.net:19900/cent-consumer",
      residence: "https://cent.xymind.net:19900/platform-residence",
      finance: "https://cent.xymind.net:19900/cent-biz-fin",
      face: "https://cent.xymind.net:19900/cent-face",
      iotDate: "https://cent.xymind.net:19900/cent-iot-data/",
      industrial: "https://cent.xymind.net:19900/platform-industrial",
      upgrade: "https://cent.xymind.net:19900/cent-upgrade",
      attendance: "https://cent.xymind.net:19900/cent-attendance",
      product: "https://cent.xymind.net:19900/cent-product",
      smartHome: "https://cent.xymind.net:19040/uploadApi/",
      iot: "https://cent.xymind.net:19900/iot-webapi",
      workSummary: "https://cent.xymind.net:19900/cent-bi",
      sdkAppId: 1400694143,
      h5View: "/h5/view/",
      healthAged: "https://cent.xymind.net:19900/platform-health-aged",
      smarthome: "https://cent.xymind.net:19900/cent-smarthome",
      flow: "https://cent.xymind.net:19900/cent-workflow",
      meeting: "https://cent.xymind.net:19900/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://cent.xymind.net:19900/cent-oam",
      iotProduct: "https://cent.xymind.net:19900/productcore-webapi",
      iotService: "https://cent.xymind.net:19900/devicecore-webapi",
      initConfig: "https://cent.xymind.net:19900/cent-init-config",
      exam: "https://cent.xymind.net:19900/cent-exam",
      service: "https://cent.xymind.net:19900/service-alliance",
    },
    pre: {
      common: "https://cent-pre.xhmind.com:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent-pre.xhmind.com:9900/cent-data-core",
      workorder: "https://cent-pre.xhmind.com:9900/cent-order",
      school: "https://cent-pre.xhmind.com:9900/platform-campus",
      patrol: "https://cent-pre.xhmind.com:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent-pre.xhmind.com:9900/cent-question",
      security: "https://cent-pre.xhmind.com:9900/cent-security",
      vehicle: "https://cent-pre.xhmind.com:9900/cent-vehicle",
      mApi: "https://cent-pre.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent-pre.xhmind.com:9900/cent-talkback",
      device: "https://cent-pre.xhmind.com:9900/cent-device",
      socketLogin: "https://cent-pre.xhmind.com:9900/cent-message",
      business: "https://cent-pre.xhmind.com:9900/platform-business",
      park: "https://cent-pre.xhmind.com:9900/cent-zone-operation",
      eesd: "https://cent-pre.xhmind.com:9900/cent-eesd",
      auth: "https://cent-pre.xhmind.com:9900/cent-auth",
      ifmDynamicServeUrl: "https://cent-pre.xhmind.com:9900/cent-consumer",
      residence: "https://cent-pre.xhmind.com:9900/platform-residence",
      finance: "https://cent-pre.xhmind.com:9900/cent-biz-fin",
      face: "https://cent-pre.xhmind.com:9900/cent-face",
      iotDate: "https://cent-pre.xhmind.com:9900/cent-iot-data/",
      industrial: "https://cent-pre.xhmind.com:9900/platform-industrial",
      upgrade: "https://cent-pre.xhmind.com:9900/cent-upgrade",
      product: "https://cent-pre.xhmind.com:9900/cent-product",
      attendance: "https://cent-pre.xhmind.com:9900/cent-attendance",
      iot: "https://cent-pre.xhmind.com:9900/iot-webapi",
      workSummary: "https://cent-pre.xhmind.com:9900/cent-bi",
      sdkAppId: 1400694207,
      h5View: "/h5/view/",
      healthAged: "https://cent-pre.xhmind.com:9900/platform-health-aged",
      smarthome: "https://cent-pre.xhmind.com:9900/cent-smarthome",
      flow: "https://cent-pre.xhmind.com:9900/cent-workflow",
      meeting: "https://cent-pre.xhmind.com:9900/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://cent-pre.xhmind.com:9900/cent-oam",
      iotProduct: "https://cent-pre.xhmind.com:9900/productcore-webapi",
      iotService: "https://cent-pre.xhmind.com:9900/devicecore-webapi",
      initConfig: "https://cent-pre.xhmind.com:9900/cent-init-config",
      service: "https://cent-pre.xhmind.com:9900/service-alliance",
    },
    production: {
      common: "https://cent.xhmind.com:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent.xhmind.com:9900/cent-data-core",
      workorder: "https://cent.xhmind.com:9900/cent-order",
      school: "https://cent.xhmind.com:9900/platform-campus",
      patrol: "https://cent.xhmind.com:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xhmind.com:9900/cent-question",
      security: "https://cent.xhmind.com:9900/cent-security",
      vehicle: "https://cent.xhmind.com:9900/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent.xhmind.com:9900/cent-talkback",
      device: "https://cent.xhmind.com:9900/cent-device",
      socketLogin: "https://cent.xhmind.com:9900/cent-message",
      business: "https://cent.xhmind.com:9900/platform-business",
      park: "https://cent.xhmind.com:9900/cent-zone-operation",
      eesd: "https://cent.xhmind.com:9900/cent-eesd",
      auth: "https://cent.xhmind.com:9900/cent-auth",
      ifmDynamicServeUrl: "https://cent.xhmind.com:9900/cent-consumer",
      residence: "https://cent.xhmind.com:9900/platform-residence",
      finance: "https://cent.xhmind.com:9900/cent-biz-fin",
      face: "https://cent.xhmind.com:9900/cent-face",
      industrial: "https://cent.xhmind.com:9900/platform-industrial",
      upgrade: "https://cent.xhmind.com:9900/cent-upgrade",
      product: "https://cent.xhmind.com:9900/cent-product",
      attendance: "https://cent.xhmind.com:9900/cent-attendance",
      iot: "https://cent.xhmind.com:9900/iot-webapi",
      workSummary: "https://cent.xhmind.com:9900/cent-bi",
      sdkAppId: 1400677520,
      h5View: "/h5/view/",
      healthAged: "https://cent.xhmind.com:9900/platform-health-aged",
      smarthome: "https://cent.xhmind.com:9900/cent-smarthome",
      flow: "https://cent.xhmind.com:9900/cent-workflow",
      meeting: "https://cent.xhmind.com:9900/cent-boardroom",
      baiduAk: "EL929iES4ftStTn1vDkt7FUh98Rzup1N",
      oam: "https://cent.xhmind.com:9900/cent-oam",
      iotProduct: "https://cent.xhmind.com:9900/productcore-webapi",
      iotService: "https://cent.xhmind.com:9900/devicecore-webapi",
      initConfig: "https://cent.xhmind.com:9900/cent-init-config",
      service: "https://cent.xhmind.com:9900/service-alliance",
    },
  }
};
